export default __webpack_public_path__ + "static/tarbot-6594fad59af543652aad7ec68d8980fe.jpeg";